import { UI, type Lang } from '@ringring/core';
import { Logo } from './lang';
import { Icon } from './Icon';

export function Sidebar({
  lang,
  venueId,
  staff = false,
  venueName,
  page = 'home',
}: {
  lang: Lang;
  venueId?: string;
  staff?: boolean;
  venueName?: string;
  page?: 'home' | 'settings' | 'feedback';
}) {
  const t = UI[lang];
  const base = `#/dashboard/${encodeURIComponent(venueId ?? '')}`;
  return (
    <aside className="sidebar">
      <a className="sidebar-brand" href={staff ? '#/' : base}>
        <Logo reverse />
      </a>
      <div className="sidebar-workspace">
        <span className="venue-monogram" aria-hidden="true">
          {venueName?.slice(0, 1) || <Icon name="location" />}
        </span>
        <div>
          <span className="eyebrow">{staff ? t.design_team_space : t.design_restaurant_space}</span>
          <strong>{venueName || t.venue_details}</strong>
        </div>
      </div>
      <p className="sidebar-caption">{t.design_workspace}</p>
      <nav aria-label={t.design_workspace}>
        {staff ? (
          <>
            <a
              className="nav-item current"
              href="#service-orders"
              onClick={(e) => {
                e.preventDefault();
                document.getElementById('service-orders')?.scrollIntoView();
              }}
              aria-current="page"
            >
              <Icon name="orders" />
              {t.orders}
              <Icon name="arrow" />
            </a>
            <a className="nav-item" href={venueId ? base : '#/dashboard'}>
              <Icon name="grid" />
              {t.admin_nav}
            </a>
          </>
        ) : (
          <>
            <a className={`nav-item ${page === 'home' ? 'current' : ''}`} href={base} aria-current={page === 'home' ? 'page' : undefined}>
              <Icon name="grid" />
              {t.dashboard}
            </a>
            <a className={`nav-item ${page === 'feedback' ? 'current' : ''}`} href={`${base}/feedback`} aria-current={page === 'feedback' ? 'page' : undefined}>
              <Icon name="message" />
              {t.feedback_nav}
            </a>
            <a className={`nav-item ${page === 'settings' ? 'current' : ''}`} href={`${base}/settings`} aria-current={page === 'settings' ? 'page' : undefined}>
              <Icon name="settings" />
              {t.settings}
            </a>
            <button className="nav-item" type="button" onClick={() => document.getElementById('account')?.scrollIntoView()}>
              <Icon name="user" />
              {t.account}
            </button>
          </>
        )}
      </nav>
      <div className="sidebar-note">
        <Icon name="bell" />
        <p>{t.design_sidebar_note}</p>
        <span className="sidebar-rule" />
      </div>
      <div className="sidebar-footer">
        <span className="signal-dot" />
        {t.design_hospitality}
      </div>
    </aside>
  );
}
